/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentPackageAcceptTemplatesMemberViewController(
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    PackageAcceptTemplatesService: JS5Object
) {

    const setupMembers = () => {

        //
        // TODO
        //
        // Make this not spaghetti.
        //

        let availableMediaAcceptProfiles: JS5Object[] = [];
        let availableMediaAcceptProfileTypes: string[] = [];
        let mediaAcceptProfiles: JS5Object[] =
            this.contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles;

        _.forIn(mediaAcceptProfiles, (mediaAcceptProfile: JS5Object) => {
            availableMediaAcceptProfiles.push(mediaAcceptProfile);
        });
        _.set(this, 'contentPackageAcceptTemplateContainer.members', {});
        availableMediaAcceptProfiles = _.flatMap(availableMediaAcceptProfiles);

        _.forEach(availableMediaAcceptProfiles, (availableMediaAcceptProfile: JS5Object) => {
            availableMediaAcceptProfileTypes.push(availableMediaAcceptProfile.type)
        });
        availableMediaAcceptProfileTypes = _.uniq(availableMediaAcceptProfileTypes);
        _.forEach(availableMediaAcceptProfileTypes, (availableMediaAcceptProfileType: string) => {
            _.set(this, `contentPackageAcceptTemplateContainer.members.${availableMediaAcceptProfileType}`,
                _.map(
                    _.get(this.contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles,
                        availableMediaAcceptProfileType),
                    (mediaAcceptProfile: JS5Object) => {
                        return {
                            acceptProfile: mediaAcceptProfile,
                            validationType: 'NOT_APPLICABLE'
                        };
                    }));
        });
    };

    const setMediaAcceptProfileTypes = (mediaAcceptProfiles: JS5Object[]) => {
        //
        // When the selected PAT changes, build collection of MAPs
        // that are interpolated in the ng-repeat
        //
        this.mediaAcceptProfiles = [];
        _.forIn(mediaAcceptProfiles, (value: JS5Object, key: string) => {
                this.mediaAcceptProfiles.push({
                    mediaAcceptProfileType: key,
                    mediaAcceptProfiles: value
                });
            }
        );
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.mediaAcceptProfiles = [];

        this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
    };

    this.$postLink = () => {
        //
        // After all of the bindings are available set the PAT in
        // the PAT dropdown
        //
        $timeout(() => {
            let packageAcceptTempmlate = _.find(this.packageAcceptTemplates, (packageAcceptTemplate: JS5Object) => {
                let patID = _.get(packageAcceptTemplate, 'id');
                let cpatID = _.get(this, 'contentPackageAcceptTemplateContainer.packageAcceptTemplate.id');
                return patID === cpatID;
            });
            _.set(this, 'packageAcceptTemplate', packageAcceptTempmlate);
            setMediaAcceptProfileTypes(_.get(this, 'packageAcceptTemplate.mediaAcceptProfiles'));

            this.loadingIndicator.show = false;
        });
    };

    this.$onChanges = () => {
        //
        // Handles any changes to the PAT binding
        //
        setMediaAcceptProfileTypes(_.get(this, 'packageAcceptTemplate.mediaAcceptProfiles'));
    };


    //================//
    // Template Logic //
    //================//

    this.onSelectedPackageAcceptTemplateChangeHandler = () => {
        PackageAcceptTemplatesService.getPackageAcceptTemplates({view: 'EXTENDED'})
            .then((packageAcceptTemplates: JS5Object) => {
                this.packageAcceptTemplates = packageAcceptTemplates;
                _.forEach(this.packageAcceptTemplates, (template: JS5Object) => {
                    template.type = _.camelCase(template.name);
                    template.mediaAcceptProfiles = _.groupBy(template.mediaAcceptProfiles, 'type');
                });
                setupMembers();
                setMediaAcceptProfileTypes(
                    _.get(this, 'contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles'));
            });

    };

}

angular.module('prism-ui.content').component('contentPackageAcceptTemplatesMemberView', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/content-package-accept-templates-member-view-template.html',
    controller: ContentPackageAcceptTemplatesMemberViewController,
    bindings: {
        contentPackageAcceptTemplateContainer: '<',
        packageAcceptTemplates: '<',
        validationTypes: '<'
    }
});
